import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {PanelUserCollection} from '@/model/collection/PanelUserCollection'
import {VisualizationMode} from '@/model/resource/VisualizationMode'
import SearchPanelUser from '@/components/SearchPanelUser.vue'

export class InputVisualizationModeSchema extends Schema {
  collectionPanelUser = new PanelUserCollection().noPagination()

  readonly name = 'InputVisualizationMode'

  inputFields = ['description']
  editFields = ['idVisualizationModePk', 'description']

  readonly fieldSet: FieldSet<VisualizationMode> = {
    idVisualizationModePk: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        label: this.translateFrom(schema.fieldName),
        required: true,
        disabled: true,
      },
    }),
    description: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 100,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    responsavelPermitido: (schema): FieldComponent => ({
      is: SearchPanelUser,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'col-span-2',
        collection: this.collectionPanelUser,
        noResultLabel: this.translateFrom('noResultLabel'),
        noOptionsLabel: this.translateFrom('noOptionsLabel'),
        required: true,
      },
    }),
  }
}
